import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { captureLeadEmail } from '../utils/captureLeadEmail';
import PageSEO from './PageSEO';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    subject: '',
    message: ''
  });
  const [captchaToken, setCaptchaToken] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEmailBlur = () => {
    captureLeadEmail(formData.email, window.location.pathname, { context: 'contact', full_name: formData.fullName, subject: formData.subject });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (siteKey && !captchaToken) {
      setStatus({ type: 'error', message: 'Please complete the captcha.' });
      return;
    }
    setSubmitting(true);
    setStatus({ type: '', message: '' });
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fullName: formData.fullName,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          captchaToken
        })
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Unable to send message.');
      }
      setStatus({ type: 'success', message: 'Message sent! We will get back to you soon.' });
      setFormData({ fullName: '', email: '', subject: '', message: '' });
      setCaptchaToken('');
    } catch (err) {
      setStatus({ type: 'error', message: err.message || 'Unable to send message.' });
    } finally {
      setSubmitting(false);
    }
  };

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

  return (
    <main className="App-main contact-page">
      <PageSEO title="Contact Rentual | Tenant Screening Support" description="Get in touch with the Rentual team. Questions about tenant screening, your account, or the platform? We're here to help." path="/contact" />
      <h2>Contact rentual.co</h2>
      <p className="contact-intro">Have a question about leasing or rent payments? Send a note and our team will reply shortly.</p>
      {!siteKey && (
        <div className="form-status error">
          Captcha is not configured. Set REACT_APP_RECAPTCHA_SITE_KEY and reload.
        </div>
      )}
      <form className="auth-form contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="fullName">Full name</label>
          <input
            id="fullName"
            name="fullName"
            type="text"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            onBlur={handleEmailBlur}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            id="subject"
            name="subject"
            type="text"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            rows="6"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        {siteKey && (
          <div className="form-group captcha-group">
            <ReCAPTCHA
              sitekey={siteKey}
              onChange={(token) => setCaptchaToken(token || '')}
            />
          </div>
        )}
        {status.message && (
          <div className={`form-status ${status.type}`}>{status.message}</div>
        )}
        <div className="form-actions">
          <button type="submit" className="primary-button" disabled={submitting}>
            {submitting ? 'Sending...' : 'Send message'}
          </button>
        </div>
      </form>

      <div className="card" style={{ marginTop: '1.5rem', padding: '1.25rem' }}>
        <h3 style={{ marginTop: 0 }}>Support Phone</h3>
        <p className="status-text" style={{ marginBottom: '0.75rem' }}>
          For questions about screening results, tenant disputes, or account support, reach us anytime.
        </p>
        <p className="status-text" style={{ margin: 0 }}>
          (289) 216-9928
        </p>
      </div>
    </main>
  );
};

export default ContactPage;
